<fw-dialog width="small" [showClose]="false">
  <fw-dialog-header>
    <fw-icon>warning</fw-icon>
    <h3>{{ 'confirmImportDialog.confirmationImport' | translate }}</h3>
  </fw-dialog-header>
  <fw-dialog-content>
     <span [innerHTML]="'confirmImportDialog.confirmationContent' | translate | interpolate:data.countErrorFiles"></span>
  </fw-dialog-content>
  <fw-dialog-actions>
     <fw-button color="danger" variant="outline" (click)="dialogRef.close(false)" test-id="back">
      {{ 'confirmImportDialog.backToUpload' | translate }}
    </fw-button>
     <fw-button color="danger" (click)="dialogRef.close(true)" test-id="confirm">
      {{ 'confirmImportDialog.yesContinue' | translate }}
    </fw-button>
  </fw-dialog-actions>
</fw-dialog>
